'use client';

import React, { useEffect, useRef, useState } from 'react';

import { LoginModalProps } from '@/widgets/LoginModal/models';
import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { registerClientPushToken } from '@/utilities/requestClientPushNotification';

import PhoneNumberStep from '../../../app/user/login/_components/LoginSteps/PhoneNumberStep';
import ValidationCodeStep from '../../../app/user/login/_components/LoginSteps/ValidationCodeStep';
import { loginStepsType } from '../../../app/user/login/_components/models';

const safeCall = (callback?: () => void) => {
    try {
        callback?.();
    } catch {
        return;
    }
};

const LoginModal = ({
    onUserLogin,
    onClose,
    hasCloseButton = true,
    isMandatory = false,
    hasRequestNotification = true,
    initialPhoneNumber = '',
    analytics
}: LoginModalProps) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const analyticsRef = useRef(analytics);

    const [isUserRegistered, setIsUserRegistered] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber);
    const [step, setStep] = useState<loginStepsType>('phoneNumber');

    const canClose = !isMandatory;

    useEffect(() => {
        analyticsRef.current = analytics;
    }, [analytics]);

    useEffect(() => {
        safeCall(() => analyticsRef.current?.onPopupShown?.());
    }, []);

    const handleRequestNotification = async () => {
        if (hasRequestNotification) {
            await registerClientPushToken();
        }
    };

    const handelNextStep = (nextStep: loginStepsType) => {
        if (nextStep === 'register') {
            void handleRequestNotification();
            safeCall(onUserLogin);
        } else {
            setStep(nextStep);
        }
    };

    const loginStepComponents = {
        phoneNumber: (
            <PhoneNumberStep
                onNextStep={handelNextStep}
                onIsUserRegistered={setIsUserRegistered}
                onPhoneNumber={setPhoneNumber}
                initialPhoneNumber={initialPhoneNumber}
                onOtpCodeRequested={() => safeCall(() => analyticsRef.current?.onOtpCodeRequested?.())}
            />
        ),
        validationCode: (
            <ValidationCodeStep
                onNextStep={handelNextStep}
                isUserRegistered={isUserRegistered}
                phoneNumber={phoneNumber}
                onOtpVerified={() => safeCall(() => analyticsRef.current?.onOtpVerified?.())}
            />
        )
    };

    return (
        <div ref={containerRef}>
            <SwipeableDrawer
                hasCloseButton={canClose && hasCloseButton}
                open
                onClose={canClose ? onClose : undefined}
                disableEscapeKeyDown={isMandatory}
                title='ورود و ثبت نام'>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/*@ts-expect-error*/}
                <div className='px-6 pb-6 pt-4'>{loginStepComponents[step]}</div>
            </SwipeableDrawer>
        </div>
    );
};

export default LoginModal;
